<style lang="scss" src='./Footer.scss' scoped></style>
<template src="./Footer.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";

  export default {
    name: 'StoreFooter',
    components: {

    },
    data() {
      return {

      };
    },
    computed: {
      // ...mapState("Main", {
      //   loading: (state) => state.loading,
      // }),
    },

    methods: {
      // ...mapActions(["Main"]),
      // ...mapMutations(["Main"]),
    },

    beforeCreate() {},

    created() {},

    mounted() {

    },

    beforeDestroy() {

    },
  };

</script>
